import React from 'react';
import { useGlobalValue } from '../../../state/GlobalProvider';
import { format, roundValues } from '../../../utils';
import styles from './ProfitAndLossChart.module.sass';

const ProfitAndLossChartLegend = props => {
  const {
    data
  } = props;
  const {
    KPI1 = {},
    KPI2 = {},
    KPI3 = {},
    KPI4 = {},
    KPI5 = {}
  } = data || {};
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("div", {
    className: styles['legend']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['value-container']
  }, /*#__PURE__*/React.createElement("small", {
    className: styles['label']
  }, i18n`${KPI1.name}`), /*#__PURE__*/React.createElement("h5", null, format(KPI1.value))), /*#__PURE__*/React.createElement("div", {
    className: styles['value-container']
  }, /*#__PURE__*/React.createElement("small", {
    className: styles['label']
  }, i18n`${KPI2.name}`), /*#__PURE__*/React.createElement("h5", null, format(KPI2.value))), /*#__PURE__*/React.createElement("div", {
    className: styles['value-container']
  }, /*#__PURE__*/React.createElement("small", {
    className: styles['label']
  }, i18n`${KPI3.name}`), /*#__PURE__*/React.createElement("h5", null, `${roundValues(KPI3.value)} %`)), /*#__PURE__*/React.createElement("div", {
    className: styles['value-container']
  }, /*#__PURE__*/React.createElement("small", {
    className: styles['label']
  }, i18n`${KPI4.name}`), /*#__PURE__*/React.createElement("h5", null, `${roundValues(KPI4.value)} %`)), /*#__PURE__*/React.createElement("div", {
    className: styles['value-container']
  }, /*#__PURE__*/React.createElement("small", {
    className: styles['label']
  }, i18n`${KPI5.name}`), /*#__PURE__*/React.createElement("h5", null, `${roundValues(KPI5.value)} %`)), /*#__PURE__*/React.createElement("div", {
    className: styles['value-container']
  }, /*#__PURE__*/React.createElement("small", {
    className: styles['label']
  }, i18n`Net Income`), /*#__PURE__*/React.createElement("div", {
    className: styles['legend-line']
  }))));
};

export default ProfitAndLossChartLegend;